var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgDeleteMessageIcon = function SvgDeleteMessageIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#545454",
    d: "M5 15.833c0 .917.75 1.667 1.667 1.667h6.666c.917 0 1.667-.75 1.667-1.667v-10H5v10zM7.05 9.9l1.175-1.175L10 10.492l1.767-1.767L12.942 9.9l-1.767 1.767 1.767 1.766-1.175 1.175L10 12.842l-1.767 1.766-1.175-1.175 1.767-1.766L7.05 9.9zm5.867-6.567-.834-.833H7.917l-.834.833H4.167V5h11.666V3.333h-2.916z"
  })));
};

export default SvgDeleteMessageIcon;